if (window.Spartez === undefined || window.Spartez.Shared === undefined) {
	throw "window.Spartez or window.Spartez.Shared is not set up";
}

export default window.Spartez.Shared;


// WEBPACK FOOTER //
// ./src/shared.js